<template>
  <div id="Admin_AllFinancialTable">
    <!-- 銷帳總表 -->
    <div
      id="sales_account"
      class="tab-pane fade show active mb-4"
      role="tabpanel"
      aria-labelledby="sales_account"
    >
      <div class="col-12 pt-2 table-style">
        <v-query-layout>
          <!-- 1 -->
          <v-label
            slot="ql1-text-1"
            for="query-keyword"
            LabText="篩選資料："
            Labbold="true"
          />
          <input
            id="query-keyword"
            class="input-style"
            type="text"
            slot="ql1-input-1"
            placeholder="請輸入關鍵字"
            v-model="filter"
          >
          <!-- 2 -->
          <v-label
            slot="ql2-text-1"
            LabText="繳款項目日期(起)："
            Labbold="true"
          />
          <a-locale-provider slot="ql2-input-1" :locale="zhTW">
            <a-date-picker
              size="large"
              @change="onDebtDateStart"
              :format="dateFormat"
              v-model="timeDebtDateStart"
            />
          </a-locale-provider>
          <v-label
            slot="ql2-text-2"
            class="ml-2"
            LabText="繳款項目日期(迄)："
            Labbold="true"
          />
          <a-locale-provider slot="ql2-input-2" :locale="zhTW">
            <a-date-picker
              size="large"
              @change="onDebtDateEnd"
              :format="dateFormat"
              v-model="timeDebtDateEnd"
            />
          </a-locale-provider>
          <div slot="qcbutton2">
            <v-button
              class="ml-2"
              btn-text="查詢"
              btnOutline="primary"
              @click.native="InquireFeeitemQuery"
            >
              <font-awesome-icon
                slot="icon"
                icon="search"
              />
            </v-button>
            <v-button
              class="ml-2"
              btn-text="清除"
              btnOutline="secondary"
              @click.native="ClearCondition"
            >
              <font-awesome-icon
                slot="icon"
                icon="search-minus"
              />
            </v-button>
          </div>
          <!-- 3 -->
          <v-label
            slot="ql3-text-1"
            for="query-page"
            LabText="筆數："
            Labbold="true"
          />
          <v-page
            slot="ql3-input-1"
            id="query-page"
            @RecPerPage="RecPerPage"
          />
        </v-query-layout>
        <hr>
        <!-- 表格資料 -->
        <div class="row px-3">
          <template>
            <b-table
              hover
              small
              bordered
              show-empty
              empty-text="目前無資料"
              responsive
              :items="items"
              :fields="fields"
              :filter="filter"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :current-page="currentPage"
              :sort-direction="sortDirection"
              @filtered="onFiltered"
            >
              <!-- 繳費通路管道 -->
              <template v-slot:cell(PayApproach)="data">
                <div
                  v-for="Pay in PayApproachSelect"
                  :key="Pay.id"
                  :value="Pay.value"
                >
                  <div v-if="Pay.value === data.item.PayApproach">
                    {{ Pay.text }}
                  </div>
                </div>
              </template>
              <!-- 匯出報表 -->
              <template v-slot:cell(Actions)="data">
                <v-button
                  btn-text="匯出報表"
                  btnSize="sm"
                  btnType="primary"
                  @click.native="PostReportSummaryexport(data.item.DebtConfirmNo)"
                />
              </template>
            </b-table>
            <!-- 分頁 -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0 mb-4"
            />
          </template>
        </div>
      </div>
    </div>
    <br>
  </div>
</template>

<script>
import $ from 'jquery'
import md5 from 'js-md5'
import moment from 'moment'
import vLabel from '@/components/Features/Label'
import vQueryLayout from '@/components/Layout/QueryLayout'
import { apiReportQuerysummary, apiReportSummaryexport } from '../../../Api/api'
import 'ant-design-vue/lib/date-picker/style/css'
import zhTW from 'ant-design-vue/lib/locale-provider/zh_TW'
export default {
  name: 'Admin_AllFinancialTable',
  components: {
    'v-label': vLabel,
    'v-query-layout': vQueryLayout
  },
  data () {
    return {
      items: [],
      fields: [
        { key: 'SerialNo', label: '#', thClass: 'table-th', sortable: true, variant: 'info' },
        { key: 'DebtDate', label: '繳款項目入帳日期', thClass: 'table-th', sortable: true },
        { key: 'PayApproach', label: '繳費通路管道', thClass: 'table-th', sortable: true },
        { key: 'DebtConfirmNo', label: '銷帳批號', thClass: 'table-th' },
        { key: 'Actions', label: '功能', thClass: 'table-th' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      filter: null,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      PayApproach: '',
      PayApproachSelect: [
        { value: 'C', text: '信用卡' },
        { value: 'I', text: '一卡通' },
        { value: 'L', text: 'LINE Pay' },
        { value: 'B', text: '土地銀行' },
        { value: 'H', text: '現金' }
      ],
      DebtConfirmNo: '',
      DebtDateStart: '',
      DebtDateEnd: '',
      zhTW,
      dateFormat: 'YYYY/MM/DD',
      monthFormat: 'YYYY/MM',
      QueryData: {},
      timeDebtDateStart: undefined,
      timeDebtDateEnd: undefined
    }
  },
  mounted () {
    this.PostReportQuerysummary()
  },
  methods: {
    moment,
    RecPerPage (SublayerPage) { // 組件筆數
      this.perPage = SublayerPage
    },
    onDebtDateStart (date, dateString) {
      this.timeDebtDateStart = date
      this.DebtDateStart = dateString
    },
    onDebtDateEnd (date, dateString) {
      this.timeDebtDateEnd = date
      this.DebtDateEnd = dateString
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    PostReportQuerysummary () { // 查詢銷帳總表 B_API018
      // 定義資料
      const vm = this
      // API預設資料
      const IdentityData = JSON.parse(sessionStorage.getItem('Identity'))
      // 查詢條件
      const AllQuery = JSON.parse(sessionStorage.getItem('AllQuery'))
      // 判斷帳號身分
      const Backend = md5('管理者')
      var NewData
      if (Backend === sessionStorage.getItem('Backend')) {
        vm.Backend = true
        if (!AllQuery) { // 沒查詢條件，預設入帳日期為空值
          IdentityData.DebtDateStart = ''
          IdentityData.DebtDateEnd = ''
          NewData = IdentityData
        } else {
          vm.timeDebtDateStart = (AllQuery.timeDebtDateStart === 'undefined') ? undefined : moment(AllQuery.timeDebtDateStart, vm.dateFormat)
          vm.timeDebtDateEnd = (AllQuery.timeDebtDateEnd === 'undefined') ? undefined : moment(AllQuery.timeDebtDateEnd, vm.dateFormat)
          NewData = Object.assign(IdentityData, AllQuery)
        }
      } else {
        this.$bus.$emit('Modals', '權限不足，無法使用此頁面。')
        $('#CheckError').modal('show')
        return false
      }
      // 呼叫API
      apiReportQuerysummary(NewData).then(
        res => {
          if (res !== undefined) {
            for (let index = 0; index < res.Data.length; index++) {
              const json = res.Data[index]
              json.SerialNo = index + 1
            }
            vm.items = res.Data
            vm.totalRows = res.Data.length
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    InquireFeeitemQuery () { // 查詢條件
      // 定義資料
      var NewData
      const vm = this
      NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.DebtDateStart = vm.DebtDateStart
      NewData.DebtDateEnd = vm.DebtDateEnd
      // 紀錄查詢條件
      vm.QueryData = {}
      vm.QueryData.DebtDateStart = vm.DebtDateStart
      vm.QueryData.DebtDateEnd = vm.DebtDateEnd
      vm.QueryData.timeDebtDateStart = (vm.timeDebtDateStart === undefined || vm.timeDebtDateStart === null) ? 'undefined' : vm.timeDebtDateStart
      vm.QueryData.timeDebtDateEnd = (vm.timeDebtDateEnd === undefined || vm.timeDebtDateEnd === null) ? 'undefined' : vm.timeDebtDateEnd
      sessionStorage.setItem('AllQuery', JSON.stringify(vm.QueryData))
      // 呼叫API
      apiReportQuerysummary(NewData).then(
        res => {
          if (res !== undefined) {
            for (let index = 0; index < res.Data.length; index++) {
              const json = res.Data[index]
              json.SerialNo = index + 1
            }
            vm.items = res.Data
            vm.totalRows = res.Data.length
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    ClearCondition () { // 清除查詢條件
      sessionStorage.removeItem('AllQuery')
      var vm = this
      vm.DebtDateStart = ''
      vm.DebtDateEnd = ''
      vm.timeDebtDateStart = undefined
      vm.timeDebtDateEnd = undefined
      vm.items = []
      vm.PostReportQuerysummary()
    },
    PostReportSummaryexport (data) { // 匯出_銷帳總表 B_API 022
      // 定義資料
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.DebtConfirmNo = data
      // 呼叫API
      apiReportSummaryexport(NewData).then(
        res => {
          if (res !== undefined) {
            const url = res.FileDir + '/' + res.FileName
            window.open(url)
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    }
  }
}
</script>
